import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectorRef,
  AfterViewInit,
  ElementRef,
  OnInit,
  ViewChildren,
  QueryList,
  OnDestroy
} from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import * as uuid from 'uuid';
import $ from 'jquery';
import { NotifyService } from '../../services/notify/notify.service';
import { TranslateService } from '../../services/translate/translate.service';
import { Subscription } from 'rxjs';
// https://stackoverflow.com/questions/4459379/preview-an-image-before-it-is-uploaded
@Component({
  selector: 'sd-upload-file-control',
  templateUrl: './upload-file-control.component.html',
  styleUrls: ['../../assets/css/scrollbar.scss', '../../assets/css/label.scss', './upload-file-control.component.scss']
})
export class UploadFileControlComponent implements OnInit, AfterViewInit, OnDestroy {
  id = `I${uuid.v4()}`;
  previewFiles: PreviewFile[] = [];
  @Input() label: string;
  @Input() type: 'image' | 'file' = 'file';
  @Input() disabled = false;
  @Input() extensions: string[] = [];
  @Input() max = 1;
  @Input() maxSize: number;
  @Input() maxWidth: number;
  @Input() maxHeight: number;
  @Input() srcs: string[] = [];
  @Input() previewWidth: string;
  @Input() previewHeight: string;
  @Input() align: 'left' | 'center' = 'center';
  @Output() sdChange = new EventEmitter<PreviewFile[]>();
  @ViewChildren('dragElement') dropElements: QueryList<ElementRef>;
  private subscription = new Subscription();
  private currentDropContainer: any;
  constructor(
    private ref: ChangeDetectorRef,
    private notifyService: NotifyService,
    private translateService: TranslateService) {
  }

  ngOnInit() {
    this.previewFiles = this.srcs.map(src => ({
      file: null,
      previewSrc: null,
      src,
      isPreviewImage: this.type === 'image'
    }));

  }

  ngAfterViewInit() {
    if (this.dropElements.length > 0) {
      const dropContainer = this.dropElements.first.nativeElement;
      this.currentDropContainer = dropContainer;
      dropContainer.addEventListener('dragover', (evt: Event) => {
        evt.preventDefault();
        dropContainer.style.opacity = 0.9;
        dropContainer.style.border = '2px solid grey';
      });
      dropContainer.addEventListener('dragenter', (evt: Event) => {
        evt.preventDefault();
      });
      dropContainer.addEventListener('dragleave', (evt: Event) => {
        dropContainer.style.opacity = 0.6;
        dropContainer.style.border = '2px dashed grey';
      });
      dropContainer.addEventListener('drop', async (evt: DragEvent) => {
        evt.preventDefault();
        dropContainer.style.opacity = 0.6;
        dropContainer.style.border = '2px dashed grey';
        await this.uploadFile(evt.dataTransfer);
      });
    }
    this.subscription.add(this.dropElements.changes.subscribe(() => {
      if (this.dropElements.length > 0 && this.currentDropContainer !== this.dropElements.first.nativeElement) {
        const dropContainer = this.dropElements.first.nativeElement;
        this.currentDropContainer = dropContainer;
        dropContainer.addEventListener('dragover', (evt: Event) => {
          evt.preventDefault();
          dropContainer.style.opacity = 0.9;
          dropContainer.style.border = '2px solid grey';
        });
        dropContainer.addEventListener('dragenter', (evt: Event) => {
          evt.preventDefault();
        });
        dropContainer.addEventListener('dragleave', (evt: Event) => {
          dropContainer.style.opacity = 0.6;
          dropContainer.style.border = '2px dashed grey';
        });
        dropContainer.addEventListener('drop', async (evt: DragEvent) => {
          evt.preventDefault();
          dropContainer.style.opacity = 0.6;
          dropContainer.style.border = '2px dashed grey';
          await this.uploadFile(evt.dataTransfer);
        });
      }
    }));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  reload = (previewFiles?: PreviewFile[]) => {
    if (previewFiles) {
      this.previewFiles = previewFiles;
      return;
    }
    this.previewFiles = this.srcs.map(src => ({
      file: null,
      previewSrc: null,
      src,
      isPreviewImage: this.type === 'image'
    }));
  }

  private validate = async (file: File): Promise<string> => {
    if (this.type === 'image') {
      if (file.type.split('/')[0] !== 'image') {
        return `[${file.name}] ${this.translateService.translate('Uploaded file is not an image')}`;
      }
    }
    if (this.extensions?.length) {
      const lastDot = file.name.lastIndexOf('.');
      const extension = file.name.substring(lastDot + 1);
      if (!this.extensions.some(e => e.toUpperCase() === extension.toUpperCase())) {
        return `[${file.name}] ${this.translateService.translate('Uploaded file is not match extension')} ${this.extensions.join(', ')}`;
      }
    }
    if (this.maxSize) {
      if (this.maxSize * 1024 * 1024 < file.size) {
        return `[${file.name}] ${this.translateService.translate('Max file size')} ${this.maxSize} Mbs`;
      }
    }
    if (this.type === 'image' && (this.maxWidth || this.maxHeight)) {
      const message: string = await new Promise(resolve => {
        const URL = window.URL || window.webkitURL;
        const img = new Image();
        img.onload = () => {
          if (this.maxWidth && img.width > this.maxWidth) {
            resolve(`[${file.name}] ${this.translateService.translate('Max image width')} ${this.maxWidth}px`);
          }
          if (this.maxHeight && img.height > this.maxHeight) {
            resolve(`[${file.name}] ${this.translateService.translate('Max image height')} ${this.maxHeight}px`);
          }
          resolve();
        };
        img.src = URL.createObjectURL(file);
      });
      if (message) {
        return message;
      }
    }
    return null;
  }

  private preview = () => {
    for (const previewFile of this.previewFiles.filter(e => e.file)) {
      const reader = new FileReader();
      reader.onload = (evt) => {
        previewFile.previewSrc = evt.target.result;
        previewFile.isPreviewImage = previewFile.file?.type.split('/')[0] === 'image';
        this.ref.detectChanges();
      };
      reader.readAsDataURL(previewFile.file);
    }
  }

  onUpload(previewFile?: PreviewFile) {
    if ($(`#${this.id}`).length) {
      $('body').children(`#${this.id}`).remove();
    }
    if (previewFile || this.max === 1) {
      $('body').append(`<input id="${this.id}" style="display: none" type="file" />`);
    } else {
      $('body').append(`<input id="${this.id}" style="display: none" type="file" multiple />`);
    }
    $(`#${this.id}`).on('change', async (evt: any) => {
      await this.uploadFile(evt.target, previewFile);
      $('body').children(`#${this.id}`).remove();
    });
    $(`#${this.id}`).trigger('click');
  }

  private uploadFile = async (target: DataTransfer, previewFile?: PreviewFile) => {
    if (!target.files.length) {
      return;
    }
    const files = target.files;
    if (!previewFile) {
      if (files.length + this.previewFiles.length > this.max) {
        this.notifyService.notify.warning(`${this.translateService.translate('Max number of files')} ${this.max}`);
        return;
      }
      for (let i = 0; i < files.length; i++) {
        const message = await this.validate(files.item(i));
        if (message) {
          this.notifyService.notify.warning(message);
          return;
        }
      }
      // tslint:disable-next-line: prefer-for-of
      for (let i = 0; i < files.length; i++) {
        const file = files.item(i);
        const lastDot = file.name.lastIndexOf('.');
        const extension = file.name.substring(lastDot + 1);
        this.previewFiles.push({
          file: files.item(i),
          isPreviewImage: false,
          previewSrc: null,
          src: null,
          fileName: file.name,
          extension
        });
      }
    } else {
      const idx = this.previewFiles.indexOf(previewFile);
      const file = files.item(0);
      const lastDot = file.name.lastIndexOf('.');
      const extension = file.name.substring(lastDot + 1);
      this.previewFiles[idx] = {
        file: files.item(0),
        isPreviewImage: false,
        previewSrc: null,
        src: null,
        fileName: file.name,
        extension
      };
    }
    this.preview();
    this.sdChange.emit(this.previewFiles);
    this.ref.detectChanges();
  }

  onRemove(previewFile: PreviewFile) {
    const idx = this.previewFiles.indexOf(previewFile);
    this.previewFiles.splice(idx, 1);
    this.sdChange.emit(this.previewFiles);
  }

  onDrop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.previewFiles, event.previousIndex, event.currentIndex);
    this.sdChange.emit(this.previewFiles);
  }
}

export interface PreviewFile {
  file: File;
  src: string;
  previewSrc: string | ArrayBuffer;
  isPreviewImage: boolean;
  fileName?: string;
  extension?: string;
}
